import { Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import ATTRIBUTE from '../../../../constants/attributes';

import actions from '../../../../actions';

export function section({ channel, preview, shopId }) {
  const actionsToDispatch = [];
  const value = preview.get(ATTRIBUTE.SECTION);

  if (preview.get('index') === -1) {
    actionsToDispatch.push(actions.data.addSection({ shopId, section: value }));
  }

  return {
    actions: actionsToDispatch,
    payload: Map({ type: OPERATIONS[channel].SECTION, value }),
  };
}
